'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const ScrapMagnet = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({

        // text1: "Horizontal Automatic Container Shear is ideal for cutting the metal shaped in different cross sections like round, square, channel, angle, I shape, plate and various waste structural metal at cold state. It brings convenience to the baling, storage and transportation of scrap metal materials, and also offers qualified furnace charges for smelting plants.",
        image1: ServiceDetailsImg,
        // title2: "Applications/ Use Cases/ Benefits",
        title: "Scrap Magnet",
        text2: "A scrap magnet, also referred to as a scrap metal magnet, is a specialized electromagnet designed to pick up and transport ferrous materials, such as iron and steel. The magnet is typically mounted on a crane, excavator, or other heavy machinery and can be activated and controlled by the operator to selectively lift and move scrap metal from one location to another.Scrap magnets come in various sizes and strengths, with some capable of lifting several tons of metal at once. The magnet operates by creating a magnetic field that attracts ferrous materials to its surface, allowing the operator to easily move and position the scrap metal as needed.",
        // points: [
        //     "Our machines are ingrained with hydraulic drive, and you can choose between a manual or a PLC-automatic control operation",
        //     "Supports AC Cooling/ Water Cooling",
        //     "Cutting range is 2mm - 4” and varies from model to model",
        //     "You can operate it from a remote control, which means you save on labor cost, transportation cost, space, and stock cost.",

        // ],
        // images: [
        // ],
        // content3Title: "Elevating Excellence",
        // text3: "Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for various types of roofs, such as shingle, tile, metal, and flat roofs. With their expertise, they ensure the longevity",
        // text4: "Roof Service is a category that encompasses a range of services related to roofs. These services include roof installation, repair, maintenance, and inspection. Roofing experts provide solutions for",
        // features: [
        //     {
        //         icon: "icon-crane-1",
        //         title: "Horizontal Automatic Container Shear",
        //         text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
        //         link: "#",
        //     },
        //     {
        //         icon: "icon-buildings",
        //         title: "Building Roof Repair",
        //         text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
        //         link: "#",
        //     },
        // ],
    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="High-Performance Scrap Magnet Machine"
                description="Electromagnet designed to pick up and transport ferrous materials like iron and steel. High-capacity with copper winding for industrial scrap processing."
                keywords="scrap magnet, electromagnet, ferrous material handling, copper winding magnet"
                canonicalUrl="https://ramanasteels.com/scrap-magnet"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    {/* <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul> */}
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>MAKE </th>
                                            <th>DIA OF THE MAGNET </th>
                                            <th>POWER CONSUMPTION</th>
                                            <th>WINDING </th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>RAMANA</td>
                                                <td>1650mm-2400mm</td>
                                                <td>22kw-30kw</td>
                                                <td>Copper Wire</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default ScrapMagnet;


